import { HTTP_ERROR_MESSAGES } from '@/data/http';
import { useAuthStore } from '@/stores/auth.store';
import axios, { AxiosError, type AxiosResponse } from 'axios';

import type { SignInResponse } from '@/types/api/auth';
import { PREFIX } from '@/data/prefix';

export const api = axios.create({
    baseURL: `${import.meta.env.VITE_BASE_URL}${PREFIX}`,
    timeout: 10000
});

api.interceptors.request.use(
    config => {
        const authStore = useAuthStore();
        const user = authStore.session as SignInResponse | null;

        if (user?.access_token) {
            config.headers.Authorization = `Bearer ${user.access_token}`;
        }

        return config;
    },
    error => Promise.reject(error)
);

api.interceptors.response.use(
    (response: AxiosResponse) => response,
    async (error: AxiosError) => {
        const message = error.response?.data;
        const { default: router } = await import('@/router');

        switch (message) {
            case HTTP_ERROR_MESSAGES[401]:
                const authStore = useAuthStore();
                const user = authStore.session as SignInResponse | null;
                if (user?.access_token) {
                    authStore.session = null;
                }
                router.replace('/login');
                break;
            case HTTP_ERROR_MESSAGES[500]:
                router.replace('/500');
                break;
            default:
                break;
        }

        return Promise.reject(error);
    }
);
